var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyStateNoResults(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "400pt",
    height: "280pt",
    viewBox: "0 0 250 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      stroke: "rgb(76.078431%,90.980392%,100%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 13 40.5 L 143 40.5 M 0 40.5 L 450 40.5 ",
    transform: "matrix(0.375,0,0,0.375,28.125,85.875)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(76.078431%,90.980392%,100%)",
      fillOpacity: 1
    },
    d: "M 192.269531 101.625 L 130.273438 101.625 C 130.246094 101.347656 130.234375 101.070312 130.234375 100.785156 C 130.234375 95.726562 134.28125 91.621094 139.269531 91.621094 C 140.640625 91.621094 141.941406 91.933594 143.105469 92.488281 C 145.074219 88.574219 149.085938 85.894531 153.714844 85.894531 C 158.757812 85.894531 163.070312 89.074219 164.804688 93.5625 C 165.449219 93.238281 166.171875 93.054688 166.9375 93.054688 C 167.8125 93.054688 168.636719 93.292969 169.34375 93.707031 C 171.109375 91.230469 173.984375 89.617188 177.230469 89.617188 C 182 89.617188 185.96875 93.101562 186.796875 97.695312 C 187.042969 97.65625 187.292969 97.636719 187.550781 97.636719 C 189.902344 97.636719 191.863281 99.355469 192.269531 101.625 Z M 192.269531 101.625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(76.078431%,90.980392%,100%)",
      fillOpacity: 1
    },
    d: "M 85.859375 101.613281 C 84.835938 99.191406 82.480469 97.5 79.738281 97.5 C 78.980469 97.5 78.257812 97.628906 77.578125 97.867188 C 76.292969 95.875 74.085938 94.5625 71.582031 94.5625 C 69.183594 94.5625 67.0625 95.765625 65.757812 97.609375 C 65.234375 97.300781 64.628906 97.125 63.980469 97.125 C 63.414062 97.125 62.878906 97.257812 62.40625 97.5 C 61.125 94.15625 57.941406 91.789062 54.21875 91.789062 C 50.796875 91.789062 47.835938 93.785156 46.382812 96.699219 C 45.523438 96.289062 44.5625 96.058594 43.550781 96.058594 C 40.289062 96.058594 37.574219 98.449219 36.992188 101.613281 Z M 85.859375 101.613281 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(76.078431%,90.980392%,100%)",
      fillOpacity: 1
    },
    d: "M 83.25 66.75 C 82.421875 66.75 81.75 67.421875 81.75 68.25 C 81.75 69.078125 82.421875 69.75 83.25 69.75 C 84.078125 69.75 84.75 69.078125 84.75 68.25 C 84.75 67.421875 84.078125 66.75 83.25 66.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 3,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(76.078431%,90.980392%,100%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 82 100 C 82 103.3125 79.3125 106 76 106 C 72.6875 106 70 103.3125 70 100 C 70 96.6875 72.6875 94 76 94 C 79.3125 94 82 96.6875 82 100 Z M 82 100 ",
    transform: "matrix(0.375,0,0,0.375,49.5,27.375)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(54.901961%,82.745098%,97.254902%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 74.662699 0 C 60.985616 0 49.068949 7.6875 42.787699 19.041667 C 38.433533 15.895833 33.121033 14.020833 27.381449 14.020833 C 12.631449 14.020833 0.683533 26.229167 0.683533 41.28125 C 0.683533 56.333333 12.631449 68.541667 27.381449 68.541667 C 27.693949 68.541667 28.006449 68.5 28.329366 68.489583 C 33.152283 75.572917 41.173116 80.21875 50.256449 80.21875 C 56.704366 80.21875 62.631449 77.885417 67.235616 74 C 69.641866 74.5 72.121033 74.770833 74.662699 74.770833 C 94.891866 74.770833 110.048116 58.34375 110.048116 37.697917 C 110.048116 17.052083 94.891866 0 74.662699 0 Z M 74.662699 0 ",
    transform: "matrix(-0.375,0,0,0.375,91.025856,27.375)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(55.686275%,81.960784%,95.686275%)",
      fillOpacity: 1
    },
    d: "M 66.496094 39.855469 L 71.503906 39.855469 C 71.753906 39.855469 71.960938 39.652344 71.960938 39.402344 L 71.960938 38.492188 C 71.960938 37.738281 71.34375 37.125 70.59375 37.125 L 67.40625 37.125 C 66.65625 37.125 66.039062 37.738281 66.039062 38.492188 L 66.039062 39.402344 C 66.039062 39.652344 66.246094 39.855469 66.496094 39.855469 Z M 74.007812 38.261719 L 73.554688 38.261719 C 73.417969 38.261719 73.324219 38.355469 73.324219 38.492188 L 73.324219 39.402344 C 73.324219 40.402344 72.507812 41.222656 71.503906 41.222656 L 66.496094 41.222656 C 65.492188 41.222656 64.675781 40.402344 64.675781 39.402344 L 64.675781 38.492188 C 64.675781 38.355469 64.582031 38.261719 64.445312 38.261719 L 63.992188 38.261719 C 63.238281 38.261719 62.625 38.878906 62.625 39.628906 L 62.625 49.417969 C 62.625 50.171875 63.238281 50.785156 63.992188 50.785156 L 74.007812 50.785156 C 74.761719 50.785156 75.375 50.171875 75.375 49.417969 L 75.375 39.628906 C 75.375 38.878906 74.761719 38.261719 74.007812 38.261719 Z M 67.40625 47.597656 C 67.40625 47.847656 67.203125 48.054688 66.949219 48.054688 L 66.496094 48.054688 C 66.246094 48.054688 66.039062 47.847656 66.039062 47.597656 L 66.039062 45.320312 C 66.039062 45.070312 66.246094 44.867188 66.496094 44.867188 L 66.949219 44.867188 C 67.203125 44.867188 67.40625 45.070312 67.40625 45.320312 Z M 69.683594 47.597656 C 69.683594 47.847656 69.476562 48.054688 69.226562 48.054688 L 68.773438 48.054688 C 68.523438 48.054688 68.316406 47.847656 68.316406 47.597656 L 68.316406 43.273438 C 68.316406 43.023438 68.523438 42.816406 68.773438 42.816406 L 69.226562 42.816406 C 69.476562 42.816406 69.683594 43.023438 69.683594 43.273438 Z M 71.960938 47.597656 C 71.960938 47.847656 71.753906 48.054688 71.503906 48.054688 L 71.050781 48.054688 C 70.796875 48.054688 70.59375 47.847656 70.59375 47.597656 L 70.59375 44.183594 C 70.59375 43.933594 70.796875 43.726562 71.050781 43.726562 L 71.503906 43.726562 C 71.753906 43.726562 71.960938 43.933594 71.960938 44.183594 Z M 71.960938 47.597656 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(76.078431%,90.980392%,100%)",
      fillOpacity: 1,
      strokeWidth: 3,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(55.686275%,81.960784%,95.686275%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 37.875 1.479167 C 37.875 1.479167 25.15625 -1.21875 13.208333 5.333333 C 13.208333 5.333333 21.114583 4.947917 20.729167 6.197917 C 20.34375 7.447917 14.760417 6.104167 3.583333 16.510417 C 3.583333 16.510417 6.854167 15.833333 7.822917 16.895833 C 8.78125 17.947917 2.4375 21.520833 0.114583 24.989583 C 0.114583 24.989583 12.4375 29.229167 24 23.833333 C 24 23.833333 24.770833 28.072917 40.572917 20.364583 C 56.375 12.666667 37.875 1.479167 37.875 1.479167 Z M 37.875 1.479167 ",
    transform: "matrix(0.375,0,0,0.375,83.625,106.875)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(55.686275%,81.960784%,95.686275%)",
      fillOpacity: 1
    },
    d: "M 94.582031 107.34375 L 94.828125 108.378906 L 95.605469 108.875 L 95.359375 110.179688 C 95.359375 110.179688 96 111.378906 95.929688 111.378906 L 94.820312 111.09375 L 95.429688 111.992188 L 95.160156 112.953125 L 96.035156 113.722656 L 96.007812 114.191406 L 97.414062 114.929688 L 95.886719 115.28125 L 95.066406 114.882812 L 95 113.863281 L 94.101562 113.359375 L 94.484375 111.921875 L 93.511719 110.40625 L 94.457031 110.328125 L 94.621094 109.289062 L 94.050781 108.707031 L 93.75 107.507812 Z M 94.582031 107.34375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(55.686275%,81.960784%,95.686275%)",
      fillOpacity: 1
    },
    d: "M 91.875 108.6875 L 91.859375 110.269531 L 92.5625 111.875 L 91.691406 112.195312 L 92.5 113.003906 L 91.953125 113.941406 L 93.175781 115.5625 L 91.6875 115.742188 L 90.964844 113.742188 L 91.542969 112.863281 L 90.996094 112.042969 L 90.25 111.085938 L 90.96875 110.980469 L 90.179688 109.972656 L 91.898438 109.1875 L 90.011719 108.28125 Z M 91.875 108.6875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(55.686275%,81.960784%,95.686275%)",
      fillOpacity: 1
    },
    d: "M 88.847656 110.808594 L 88.882812 112.496094 C 88.882812 112.496094 90.597656 113.980469 90.40625 113.972656 L 89.6875 113.972656 L 90.421875 114.8125 L 90.175781 115.464844 L 91.320312 116.109375 L 89.148438 115.996094 L 89.15625 114.6875 L 88.027344 113.460938 L 88.886719 113.234375 L 87.4375 112.351562 L 88.015625 111.941406 L 87.339844 111.324219 Z M 88.847656 110.808594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(76.078431%,90.980392%,100%)",
      fillOpacity: 1,
      strokeWidth: 3,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(55.686275%,81.960784%,95.686275%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 8.125 6.145833 C 8.125 6.145833 5.197917 9.427083 5.03125 18.09375 C 4.822917 28.8125 7.708333 50.25 7.708333 50.25 C 7.708333 50.25 4.520833 56.916667 4.416667 60.96875 C 4.208333 68.802083 12.5625 73.833333 17.604167 72.927083 C 22.09375 72.114583 23.947917 62.052083 25.364583 61.947917 C 26.583333 61.541667 25.770833 71.21875 30.791667 72.927083 C 37.34375 75.145833 45.5625 67.708333 46.395833 61.9375 C 46.979167 57.833333 43.916667 50.9375 43.916667 50.9375 C 43.916667 50.9375 48.427083 33.322917 48.364583 22.34375 C 48.333333 15.03125 18.614583 1.458333 18.614583 1.458333 Z M 8.125 6.145833 ",
    transform: "matrix(0.375,0,0,0.375,93.375,95.25)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(55.686275%,81.960784%,95.686275%)",
      fillOpacity: 1
    },
    d: "M 98.300781 103.945312 C 98.328125 104.058594 98.445312 106.9375 99.921875 109.503906 C 101.261719 111.832031 104.996094 111.746094 106.765625 109.757812 C 109.738281 106.417969 108.710938 103.222656 108.507812 103.222656 C 108.304688 103.222656 99.765625 100.949219 98.300781 103.945312 Z M 98.300781 103.945312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(55.686275%,81.960784%,95.686275%)",
      fillOpacity: 1
    },
    d: "M 102.234375 112.457031 C 101.824219 112.015625 102.792969 116.433594 102.953125 118.273438 C 103.023438 117.824219 103.484375 113.460938 103.738281 112.46875 C 103.65625 112.53125 103.046875 112.953125 102.234375 112.457031 Z M 102.234375 112.457031 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(76.078431%,90.980392%,100%)",
      fillOpacity: 1,
      strokeWidth: 3,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(55.686275%,81.960784%,95.686275%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 5.322917 0.6875 C 5.322917 0.6875 -1.78125 4.260417 0.427083 15.020833 C 3.354167 29.239583 25.8125 27.114583 34.1875 25.125 C 40.354167 23.614583 42.25 21.489583 47.71875 18.8125 C 47.71875 18.8125 37.40625 11.6875 36.34375 11.6875 C 35.28125 11.6875 26.25 13.979167 22.822917 13.40625 C 19.395833 12.84375 16.989583 10.3125 16.989583 10.3125 C 16.989583 10.3125 8.770833 -1.239583 5.322917 0.6875 Z M 5.322917 0.6875 ",
    transform: "matrix(0.375,0,0,0.375,93.375,95.25)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(76.078431%,90.980392%,100%)",
      fillOpacity: 1,
      strokeWidth: 3,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(55.686275%,81.960784%,95.686275%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 34.09375 5.322917 L 25.1875 13.791667 C 25.1875 13.791667 26.864583 15.041667 29.90625 17.552083 C 32.947917 20.052083 32.260417 24.3125 41.885417 26.40625 C 48.104167 27.760417 58.645833 16.40625 51.614583 5.3125 C 34.03125 12.625 34.09375 5.322917 34.09375 5.322917 Z M 34.09375 5.322917 ",
    transform: "matrix(0.375,0,0,0.375,93.375,95.25)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(76.078431%,90.980392%,100%)",
      fillOpacity: 1,
      strokeWidth: 3,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(55.686275%,81.960784%,95.686275%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 11.958333 70.677083 C 11.958333 70.677083 -15.177083 44.28125 15.010417 17.739583 C 15.010417 17.739583 25.625 8.625 40.135417 11.71875 C 40.135417 11.71875 69.53125 14.395833 77.479167 32.989583 C 85.541667 51.854167 84.802083 73.020833 56 82.59375 C 55.989583 82.59375 33.1875 87.927083 11.958333 70.677083 Z M 11.958333 70.677083 ",
    transform: "matrix(0.375,0,0,0.375,90.375,68.25)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(76.470588%,90.588235%,98.039216%)",
      fillOpacity: 1,
      strokeWidth: 3,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(55.686275%,81.960784%,95.686275%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 61.395833 18.583333 C 61.395833 18.583333 91.989583 1.635417 77.447917 33.802083 ",
    transform: "matrix(0.375,0,0,0.375,90.375,68.25)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(76.470588%,90.588235%,98.039216%)",
      fillOpacity: 1,
      strokeWidth: 3,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(55.686275%,81.960784%,95.686275%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 37.791667 12.052083 C 37.791667 12.052083 19.645833 -17.822917 16.302083 17.302083 ",
    transform: "matrix(0.375,0,0,0.375,90.375,68.25)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1,
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(100%,100%,100%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 63 14 C 61.479167 13.864583 58.541667 14.489583 57 15 C 54.020833 15.989583 51.416667 16.822917 49.09375 18 C 38.520833 12.645833 24.0625 10.104167 23.125 10 C 22.197917 8.583333 21.84375 8.270833 20 6 C 18.833333 4.5625 14 0 12 0 C 12.583333 0.583333 13.322917 0.322917 15 2 C 16.197917 3.197917 22.635417 11.3125 23.125 12.0625 C 24.0625 12.166667 25.010417 12.3125 25.979167 12.520833 C 25.979167 12.520833 38.427083 14.645833 49 20 C 49.864583 19.5625 52.427083 17.927083 57 16 C 57.854167 15.645833 59.020833 14.697917 62 14.5 C 62.96875 14.4375 64.447917 14.125 63 14 Z M 63 14 ",
    transform: "matrix(0.375,0,0,0.375,95.25,69)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1,
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(55.686275%,81.960784%,95.686275%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 57.489583 58.260417 C 54.645833 68.75 43.989583 75.40625 31.75 75.364583 C 28.708333 75.354167 25.666667 74.947917 22.729167 74.145833 C 10.5625 70.864583 1.90625 61.697917 0.28125 51.6875 C 0.239583 51.385417 0.197917 51.104167 0.166667 50.8125 C -0.166667 48.166667 0.03125 45.489583 0.71875 42.916667 C 4.239583 29.90625 20.479167 22.604167 36.145833 26.84375 C 38.958333 27.59375 41.65625 28.71875 44.177083 30.166667 C 54.791667 36.3125 60.354167 47.677083 57.489583 58.260417 Z M 57.489583 58.260417 ",
    transform: "matrix(0.375,0,0,0.375,95.25,69)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(76.470588%,90.588235%,98.039216%)",
      fillOpacity: 1,
      strokeWidth: 3,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(55.686275%,81.960784%,95.686275%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 36.71875 89.010417 C 34.28125 88.333333 31.291667 86.59375 28.53125 83.260417 C 24.208333 78.052083 29.104167 79.114583 29.104167 70.072917 C 29.104167 60.59375 43.34375 70.375 45.125 75.989583 C 45.125 75.989583 47.645833 70.520833 50.895833 74.15625 C 52.322917 75.75 49.895833 80.729167 49.895833 80.729167 C 49.895833 80.729167 42.1875 90.53125 36.71875 89.010417 Z M 36.71875 89.010417 ",
    transform: "matrix(0.375,0,0,0.375,90.375,68.25)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(55.686275%,81.960784%,95.686275%)",
      fillOpacity: 1
    },
    d: "M 95.203125 77.664062 C 95.203125 77.664062 87.8125 85.710938 95.808594 93.261719 C 95.808594 93.261719 90.023438 85.144531 95.203125 77.664062 Z M 95.203125 77.664062 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(55.686275%,81.960784%,95.686275%)",
      fillOpacity: 1
    },
    d: "M 110.109375 91.03125 C 109.566406 90.828125 108.875 91.320312 108.566406 92.132812 C 108.261719 92.945312 108.449219 93.769531 108.992188 93.976562 C 109.535156 94.183594 110.222656 93.6875 110.53125 92.875 C 110.839844 92.0625 110.648438 91.238281 110.109375 91.03125 Z M 110.109375 91.03125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(55.686275%,81.960784%,95.686275%)",
      fillOpacity: 1
    },
    d: "M 100.84375 87.519531 C 100.304688 87.316406 99.613281 87.808594 99.304688 88.621094 C 98.996094 89.433594 99.1875 90.261719 99.730469 90.464844 C 100.273438 90.671875 100.960938 90.179688 101.269531 89.363281 C 101.578125 88.550781 101.386719 87.726562 100.84375 87.519531 Z M 100.84375 87.519531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(55.686275%,81.960784%,95.686275%)",
      fillOpacity: 1
    },
    d: "M 95.828125 89.941406 C 95.828125 89.941406 96.707031 83.53125 98.28125 83.820312 C 98.28125 83.820312 98.777344 85.078125 99.308594 85.222656 C 99.410156 85.25 99.882812 82 101.835938 81.519531 C 101.835938 81.519531 107.128906 85.605469 108.21875 84.4375 C 108.050781 84.261719 106.089844 82.792969 106.464844 81.855469 C 106.671875 81.335938 111.3125 82.761719 112.019531 87.878906 C 112.308594 88.171875 113.078125 87.472656 113.570312 86.257812 C 114.484375 83.992188 114.3125 90.742188 114.320312 90.84375 C 114.324219 90.949219 114.859375 90.855469 115.421875 90.394531 C 115.984375 89.933594 114.566406 94.214844 114.351562 94.636719 C 114.140625 95.054688 116.410156 93.25 117.042969 90.257812 C 117.671875 87.261719 115.972656 83.421875 113.976562 81.828125 C 112.082031 80.316406 108.910156 77.660156 102.457031 78.855469 C 95.597656 80.132812 95.105469 86.824219 95.101562 86.941406 C 95.074219 87.710938 95.59375 89.8125 95.828125 89.941406 Z M 95.828125 89.941406 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(55.686275%,81.960784%,95.686275%)",
      fillOpacity: 1
    },
    d: "M 118.617188 80.453125 C 119.730469 79.652344 120.675781 75.890625 119.359375 75.011719 C 119.359375 75.011719 118.6875 74.746094 118.136719 75.023438 C 118.136719 75.023438 114.222656 76.828125 115.421875 78.886719 C 116.457031 80.660156 117.894531 80.96875 118.617188 80.453125 Z M 118.617188 80.453125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(55.686275%,81.960784%,95.686275%)",
      fillOpacity: 1
    },
    d: "M 97.542969 74.761719 C 96.96875 73.511719 98.019531 69.777344 99.601562 69.667969 C 99.601562 69.667969 100.316406 69.773438 100.65625 70.285156 C 100.65625 70.285156 103.160156 73.792969 101.09375 74.984375 C 99.316406 76.015625 97.917969 75.566406 97.542969 74.761719 Z M 97.542969 74.761719 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStateNoResults);
export default __webpack_public_path__ + "static/media/empty-state-no-results.da1f1539.svg";
export { ForwardRef as ReactComponent };